

export const NavTabs = () => {
	!function() {
		if ( document.getElementsByClassName('pm-tabs').length > 0 ) {
			document.body.addEventListener('click', handleTabClick );
		}
	}();

	function handleTabClick( e ) {
		if ( ! e.target.matches('.in__link') || ! e.target.closest('.pm-tabs') ) {
			return;
		}

		e.preventDefault();

		const $link = e.target;
		const index = parseInt( $link.dataset?.index ?? Array.prototype.indexOf.call( $link.closest('ul').children, $link.parentNode ) );
		const $tabs = $link.closest('.pm-tabs');

		for ( const el of $tabs.querySelectorAll('.active') ) {
			console.log(el);
			el.classList.remove('active');
		}

		$link.classList.add('active');
		$tabs.querySelectorAll('.in__content')[index].classList.add('active');

		return false;
	}
};